<template>
  <!-- 底部 -->
  <div>
    <div class="footer" id="isPCF">
      <div class="cantain">
        <div class="left">
          <div class="block_10">
            <span class="word_3" @click="go('abstract')">公司简介</span>
            <span class="locationPrev_3" @click="go('history')">发展历程</span>
            <span class="location_3" @click="go('honors')">荣誉资质</span>
            <span class="location_4" @click="go('joinUs')">加入我们</span>
          </div>
          <span class="telNext">地址：北京市朝阳区酒仙桥路4号宏源大厦13层</span>
          <span class="tel">电话：400-888-1126</span>
          <span class="telNext">邮箱：info@growlib.com</span>
        </div>
        <div class="right">
          <div class="middle">
            <span class="telPrev_1">全国统一客服热线</span>
            <span class="line"></span>
            <span class="tel_1">400-888-1126</span>
            <span class="txt_6">
             <p>北京 · 南昌 · 上海 · 深圳</p>
             <p>成都 · 杭州 · 青岛 · 武汉</p>
            </span>
          </div>
          <img
            class="public"
            src="https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/6fe47b14b3d5cc74c39994157ec80808.png"
          />
        </div>
      </div>
      <div class="bottom">
        <span class="telephonePrev" @click="go()">备案号：京ICP备16064072号-1</span>
        <span class="telephone">北京格如灵科技有限公司 版权所有</span>
      </div>
    </div>
    <div class="footerPhone" id="isMobile">
      <div class="about">
        <div @click="go('abstract')">公司介绍</div>
        <div @click="go('history')">发展历程</div>
        <div @click="go('joinUs')">加入我们</div>
      </div>
      <div class="guan">官方热线</div>
      <div class="phone">400-888-1126</div>
      <div class="time">周一至周五 09:30-18:30</div>
      <div class="web" @click="go()">
        2021© 格如灵版权所有 京ICP备16064072号-1
      </div>
      <div class="official">
        <img
          src="https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/6fe47b14b3d5cc74c39994157ec80808.png"
          alt=""
        />
        <div>关注微信公众号</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      data: {
        menu_list: []
      }
    };
  },
  created() {},
  methods: {
    go(name) {
      if (name) {
        this.$router.push({
          name
        });
      } else {
        window.location.href = 'https://beian.miit.gov.cn/';
      }
    }
  }
};
</script>
<style lang="less" scoped>
.footerPhone {
  width: 100%;
  height: 332px;
  background: #3d3e4a;
  padding: 0 48px;
  box-sizing: border-box;
  position: relative;
  .about {
    padding-top: 60px;
    display: flex;
    align-items: center;
    margin-left: -28px;
    div {
      padding: 0 28px;
      height: 24px;
      line-height: 24px;
      border-right: 1px solid #53565a;
      font-size: 24px;
      color: #9ba1aa;
      letter-spacing: 0;
      font-weight: 400;
    }
    div:nth-child(3) {
      border-right: none;
    }
  }
  .guan {
    font-size: 24px;
    color: #9ba1aa;
    letter-spacing: 0;
    font-weight: 400;
    margin-top: 28px;
    line-height: 1.5;
  }
  .phone {
    font-size: 24px;
    color: #9ba1aa;
    letter-spacing: 0;
    font-weight: 400;
    margin-top: 8px;
    line-height: 1.5;
  }
  .time {
    font-size: 24px;
    color: #9ba1aa;
    letter-spacing: 0;
    font-weight: 400;
    margin-top: 0;
    line-height: 1.5;
  }
  .web {
    font-size: 24px;
    color: #6d737c;
    letter-spacing: 2px;
    font-weight: 400;
    margin-top: 16px;
    line-height: 1.5;
  }
  .official {
    position: absolute;
    top: 54px;
    right: 48px;
    img {
      width: 144px;
      height: 144px;
      display: block;
      margin: 0 auto;
    }
    div {
      margin-top: 10px;
      font-size: 20px;
      color: #9ba1aa;
      font-weight: 400;
      text-align: center;
    }
  }
}
.footer {
  // background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_62592a9053b68/739767919.png);
  // background-size: cover;
  background: #202122;
  width: 100%;
  height: 341px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .cantain{
    width: 1200px;
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 auto;
  }
  .bottom{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 83px;
    height: 50px;
    position: absolute;
    bottom: 0;
    left: 0;
    background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_62592b8744597/162515452.png);
    background-size: 100% 100%;
    .telephonePrev{
      margin-right: 40px;
    }
  }
}

.left {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 57px;
}
.right {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  margin-top: 57px;
}
.block_10 {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
}

.word_3 {
  margin-right: 33px;
  line-height: 20px;
  white-space: nowrap;
  color: #ffffff;
  font-family: SourceHanSansCN-Bold;
  font-size: 14px;
  font-weight: 400;
}

.locationPrev_3 {
  margin-right: 33px;
  line-height: 20px;
  white-space: nowrap;
  color: #ffffff;
  font-family: SourceHanSansCN-Bold;
  font-size: 14px;
  font-weight: 400;
}

.location_3{
  margin-right: 33px;
  line-height: 20px;
  white-space: nowrap;
  color: #ffffff;
  font-family: SourceHanSansCN-Bold;
  font-size: 14px;
  font-weight: 400;
}

.location_4 {
  line-height: 20px;
  white-space: nowrap;
  color: #ffffff;
  font-family: SourceHanSansCN-Bold;
  font-size: 14px;
  font-weight: 400;
}

// .telPrev {
//   position: relative;
//   margin-top: 8px;
//   max-width: 448px;
//   height: 20px;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   line-height: 20px;
//   white-space: nowrap;
//   color: #A7A7A7;
//   font-family: SourceHanSansCN-Normal;
//   font-size: 14px;
//   font-weight: 400;
//   margin-top: 15px;
// }

.tel {
  position: relative;
  max-width: 448px;
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
  white-space: nowrap;
  color: #A7A7A7;
  font-family: SourceHanSansCN-Normal;
  font-size: 14px;
  font-weight: 400;
  margin-top: 25px;
}

.telNext {
  position: relative;
  max-width: 448px;
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
  white-space: nowrap;
  color: #A7A7A7;
  font-family: SourceHanSansCN-Normal;
  font-size: 14px;
  font-weight: 400;
  margin-top: 25px;
}

.telephonePrev {
  position: relative;
  line-height: 18px;
  white-space: pre;
  color: #A7A7A7;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
}

.telephone {
  position: relative;
  max-width: 448px;
  height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
  white-space: pre;
  color: #A7A7A7;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: 400;
}

.middle {
  height: 156px;
  display: flex;
  position: relative;
  align-items: flex-end;
  justify-content: flex-end;
  flex-direction: column;
  margin-right: 22px;
}

.line{
  display:inline-block;
  width: 53px;
  height: 2px;
  background-color: #7A7A7A;
  border-radius: 1px;
  margin: 7px 0;
  position: relative;
}
.txt_6 {
  width: 161px;
  height: 48px;
  position: relative;
  line-height: 30px;
  white-space: pre;
  color: #7A7A7A;
  line-height: 24px;
  text-align: right;
  font-family: SourceHanSansCN-Medium;
  font-size: 14px;
  font-weight: 500;
  margin-top: 6px;
}

.telPrev_1 {
  position: relative;
  max-width: 234px;
  height: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
  white-space: nowrap;
  color: #ffffff;
  font-family: SourceHanSansCN-Medium;
  font-size: 14px;
  font-weight: 500;
}

.tel_1 {
  position: relative;
  margin-top: 2px;
  line-height: 40px;
  white-space: nowrap;
  color: #FFCBA6;
  font-family: SourceHanSansCN-Bold;
  font-size: 28px;
  font-weight: 400;
}

.telNext_1 {
  position: relative;
  margin-top: 20px;
  max-width: 234px;
  height: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 25px;
  white-space: nowrap;
  color: #ffffff;
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  font-weight: 500;
}

.public {
  // margin-top: 43px;
  width: 156px;
  height: 156px;
}
@media (max-width: 750px) {
}
</style>
